import React, {Component} from 'react';
import {Field} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as addressSearchActions from "../../actions/addressSearchActions";
import * as companyActions from "../../actions/companyActions";
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';

class GeoLocation extends React.Component{
    constructor (props) {
        super(props);

        this.extractGeoData = this.extractGeoData.bind(this);
        this.showMap = this.showMap.bind(this);
    }

    areCoordinatesInitialized() {
        return (this.props.latitude != undefined && this.props.longitude != undefined);
    }

    extractGeoData() {
        if (this.props.addressId) {
            this.props.actions.getAddressDetails(this.props.addressId);
        }
    }

    showMap() {
        if (this.areCoordinatesInitialized()) {
            const BASE_LOCATON_URL = 'https://www.google.com/maps/search/?api=1&query=';
            let link = `${BASE_LOCATON_URL}${this.props.latitude},${this.props.longitude}`;
            window.open(link, '', '');
        }
    }

    render() {

        return (
            <div className="row mt-2">
                <label className="col-sm-2 col-form-label">
                    <b>{this.props.intl.formatMessage(messages.coordinates)}</b>
                </label>
                <div className="col-sm-10">
                    <div className="form-group row">
                        <div className="col-md-3">
                            <label>{this.props.intl.formatMessage(messages.longitude)}</label>
                            <Field
                                className="form-control"
                                name="latitude"
                                component="input"
                                type="text"
                                readOnly={true}
                            />
                        </div>
                        <div className="col-md-3">
                            <label>{this.props.intl.formatMessage(messages.latitude)}</label>
                            <Field
                                className="form-control"
                                name="longitude"
                                component="input"
                                type="text"
                                readOnly={true}
                            />
                        </div>
                        <div className="col-md-6">
                            <label><b>Service</b></label>
                            <br />
                            <div className="row">
                                <div className="col-md-12">
                                    <button
                                        type="button"
                                        className="btn btn-secondary waves-effect waves-light mr-3"
                                        id="extract-coordinates"
                                        onClick={this.extractGeoData}
                                    >
                                        <i className="fa fa-map-marker"/>
                                        {this.props.intl.formatMessage(messages.fetch)}
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-secondary waves-effect waves-light"
                                        id="verify-coordinates"
                                        onClick={this.showMap}
                                    >
                                        <i className="fa fa-check-square-o"/>
                                        {this.props.intl.formatMessage(messages.checkOut)}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                companyActions,
                addressSearchActions,
            ), dispatch
        )
    }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(GeoLocation));




// WEBPACK FOOTER //
// ./web/src/components/common/GeoLocation.jsx